import {orderExport} from "@/api/public";
import config from '@/config'
import {parseParam} from '@/libs/util'
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
export function  userExportTable(){
  const exportHandle=async (url,data)=>{
    var params=parseParam(data)
    const hide = message.loading('导出中...', 0);
    let result =await orderExport(data).then(res=>res.data).catch(error=>error)
    setTimeout(hide);
    //  window.open()config.baseUrl[process.env.VUE_APP_type]+url+'?'+params
    if(iscode(result,true)){
          console.log(result)
          window.open(result.data.file_url)
    }
  }
  return{
    exportHandle
  }
}